// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2TX43","delete":"styles_delete__H5z4b","update":"styles_update__g_dtI","add":"styles_add__2FFoY"};